// extracted by mini-css-extract-plugin
export default {"ModelContainer":"website-translation_ModelContainer__9276s"};